import { Decimal } from 'decimal.js';
import { PaycodeEndpoints, CodeSendMessageEndpoints } from './endpoints';
import { Paycode } from '../models';
import * as schemas from './schemas';
import { getToken } from '~/apps/shared/services/token';
import * as net from '~/lib/net';

export async function getPaycodeById(paycodeId: string): Promise<Paycode> {
  const data = await net.apiGet(PaycodeEndpoints.getPaycodeById(paycodeId), getToken());
  return schemas.PaycodeSchema.load(data);
}

export type PaycodeListFilter = {
  filter?: string;
  offset?: number;
  limit?: number;
};

export async function getOrgPaycodes(orgId: string, flt: PaycodeListFilter = null): Promise<Paycode[]> {
  const data = await net.apiGet(PaycodeEndpoints.getOrgPaycodes(orgId, flt), getToken());
  return schemas.PaycodeListSchema.load(data);
}

// Create paycode
export interface PaycodeChangeRequest {
  amount: Decimal;
  note: string;
}

export async function createPaycode(orgId: string, req: PaycodeChangeRequest) {
  const payload = schemas.PaycodeRequest.save(req);

  const data = await net.apiPost(PaycodeEndpoints.createPaycode(), getToken(), payload);
  return schemas.PaycodeSchema.load(data);
}

export async function updatePaycode(paycodeId: string, req: PaycodeChangeRequest) {
  const payload = schemas.PaycodeRequest.save(req);

  const data = await net.apiPost(PaycodeEndpoints.updatePaycode(paycodeId), getToken(), payload);
  return schemas.PaycodeSchema.load(data);
}

export async function deletePaycode(paycodeId: string) {
  const data = await net.apiDelete(PaycodeEndpoints.deletePaycode(paycodeId), getToken());
  return schemas.PaycodeSchema.load(data);
}

// Messages

export async function sendText(codeId: string, req: {to: string}) {
  const payload = schemas.MessageRequest.save(req);

  const data = await net.apiPost(CodeSendMessageEndpoints.sendTextEndpoint(codeId), getToken(), payload);
  return schemas.MessageResponse.load(data);
}

export async function sendEmail(codeId: string, req: {to: string}) {
  const payload = schemas.MessageRequest.save(req);

  const data = await net.apiPost(CodeSendMessageEndpoints.sendEmailEndpoint(codeId), getToken(), payload);
  return schemas.MessageResponse.load(data);
}
